import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { getCurrentBankCategory } from '../../../../../../redux/actions/BankActions';

import { useCarouselStyles } from './styles';

const Carrousel = ({ ...props }) => {
  const { categories, mobile, handleCategorySelected } = props;
  const classes = useCarouselStyles({ mobile });

  const [categoryValue, setCategoryValue] = useState(0);

  const dispatch = useDispatch();

  useEffect(() => {
    if (categories.length > 0) {
      dispatch(getCurrentBankCategory(categories[categoryValue]));
    }
  }, [categoryValue]);

  const calcCarouselSettings = () => {
    const settings = {
      dots: false,
      infinite: false,
      slidesToShow: 1,
      speed: 500,
      nextArrow: <KeyboardArrowRightIcon fontSize="large" color="secondary" />,
      prevArrow: <KeyboardArrowLeftIcon fontSize="large" color="secondary" />,
      onInit: () => {
        setCategoryValue(0);
      },
      beforeChange: (old, current) => {
        setCategoryValue(current);
        handleCategorySelected(false);
      },
    };
    if (window.innerWidth >= 769) {
      return { ...settings, centerMode: true, centerPadding: '80px' };
    }
    return settings;
  };

  return (
    <div className={classes.root}>
      {categories.length < 1 && (
        <>
          <div className="description">
            No tenemos categorías disponibles para canjear.
          </div>
        </>
      )}
      {categories.length > 0 && (
        <div className={classes.carousel}>
          <Slider {...calcCarouselSettings()}>
            {categories.map((category) => {
              return (
                <div
                  className={classes.carouselImgContainer}
                  key={category.categoryId}
                >
                  <img
                    data-cy={`carouselImg-${category.categoryId}`}
                    src={category.image}
                    className={`${classes.carouselImg} ${
                      mobile ? classes.imageMobile : ''
                    }`}
                  />
                </div>
              );
            })}
          </Slider>
        </div>
      )}
    </div>
  );
};

Carrousel.propTypes = {
  categories: PropTypes.array,
  mobile: PropTypes.bool,
  handleCategorySelected: PropTypes.func,
};

export default Carrousel;
